import { booleanAttribute, Component, input, ViewEncapsulation } from "@angular/core";
import { VdsIconComponent } from "@cce/design-system/icon";
import { PolymorpheusContent, PolymorpheusOutlet } from "@taiga-ui/polymorpheus";

export type VdsStatusColor = "orange" | "green" | "purple" | "red" | "grey" | "blue" | "transparent";

@Component({
    selector: "vds-status",
    templateUrl: "./status.component.html",
    styleUrl: "./status.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vds-status",
        "[class.vds-status--dark]": "mode() === 'dark'",
        "[class]": "'vds-status-' + color()"
    },
    imports: [VdsIconComponent, PolymorpheusOutlet]
})
export class VdsStatusComponent {
    /**
     * The color of the status.
     */
    color = input<VdsStatusColor>("grey");

    /**
     * Whether the status dot should be filled or outlined
     */
    fill = input(false, { transform: booleanAttribute });

    /**
     * Whether the status should hide the dot
     */
    simple = input(false, { transform: booleanAttribute });

    /**
     * Whether the status should be set to dark or light mode
     */
    mode = input<"dark" | "light">("light");

    /**
     * The icon to display in the status
     */
    leadingIcon = input<PolymorpheusContent>();
}
